/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { action, observable } from 'mobx';
import AppSectionBase from './appSectionBase';

export default class InAppSection extends AppSectionBase {
    layoutID;

    @observable count;

    subSectionAriaLabel;

    @observable
    actionList = [];

    hiddenActionList = [];

    subSectionList = [];

    banner;

    hideBanner;

    emptyState;

    sectionAppsData = {};

    compositeFilter = '';

    @observable failState = null;

    @observable showWait = false;

    constructor({
        layoutId, actionList, hiddenActionList, hideBanner,
        banner, sectionAppsData, compositeFilter,
        subSectionAriaLabel, subSectionList, emptyState, showWait = false, ...superProps
    }) {
        super(superProps);
        this.layoutId = layoutId;
        this.actionList = actionList;
        this.hiddenActionList = hiddenActionList;
        this.hideBanner = hideBanner;
        this.banner = banner;
        this.subSectionAriaLabel = subSectionAriaLabel;
        this.subSectionList = subSectionList;
        this.emptyState = emptyState;
        this.sectionAppsData = sectionAppsData;
        this.showWait = showWait;
        this.compositeFilter = compositeFilter;
    }

    @action
    updateCount(count) {
        this.count = count;
    }

    @action
    showWaitIcon(bool) {
        this.showWait = bool;
    }

    @action
    setFailState(failState) {
        this.failState = failState;
    }

    getActionItem(actionId) {
        return this.actionList.filter(
            actionItem => actionItem.getId() === actionId
        );
    }

    displayActionItem(actionId) {
        const newActionList = [];
        this.hiddenActionList.forEach(actionItem => (
            actionItem.actionId !== actionId ? newActionList : this.actionList
        ).unshift(actionItem));
        this.hiddenActionList = newActionList;
    }

    hideActionItem(actionId) {
        const newActionList = [];
        this.actionList.forEach(actionItem => (
            actionItem.actionId !== actionId ? newActionList : this.hiddenActionList
        ).push(actionItem));
        this.actionList = newActionList;
    }

    enableActionItem(actionId) {
        this.actionList.forEach((actionItem) => {
            if (actionItem.actionId === actionId) {
                actionItem.setDisabled(false);
            }
        });
    }

    disableActionItem(actionId) {
        this.actionList.forEach((actionItem) => {
            if (actionItem.actionId === actionId) {
                actionItem.setDisabled(true);
            }
        });
    }
}
